import PropTypes from "prop-types";

const FitoImage = ({emotion, style, ...props}) => {
    let imageSource;

    switch (emotion) {
        case 'half-happy':
            imageSource = './fito/fito-half-happy.png';
            break;
        case 'happy':
            imageSource = './fito/fito-happy.png';
            break;
        case 'surprised':
            imageSource = './fito/fito-surprised.png';
            break;
        default:
            imageSource = './fito/fito-happy.png';
    }

    return (
        <img src={imageSource} style={{...styles.image, ...style}} {...props} alt={emotion}/>
    );
};

FitoImage.propTypes = {
    emotion: PropTypes.oneOf(['half-happy', 'happy', 'surprised']),
    style: PropTypes.object,
};

const styles = {
    image: {
        width: '100%',
        height: '100%',
        objectFit: 'contain',
    },
};

export default FitoImage;